import { useIntl } from 'react-intl';

import { useQuery } from '@apollo/client';

import {
  WishlistListByIdQuery,
  WishlistListByIdQueryVariables,
} from '@notino/shared/definitions/types';

import messages from '@components/Universals/WishlistModifier/messages';
import { useWishlistLists } from '@components/Universals/WishlistModifier/useWishlistLists';

import wishlistListById from '../queries/wishlistListById.graphql';

import { useWishlistId } from './useWishlistId';

export const useListById = () => {
  const { listId } = useWishlistId();
  const { formatMessage } = useIntl();

  const { data } = useQuery<
    WishlistListByIdQuery,
    WishlistListByIdQueryVariables
  >(wishlistListById, {
    errorPolicy: 'all',
    fetchPolicy: 'cache-first',
    skip: !listId, // when shared list
    variables: {
      id: listId!,
    },
  });

  const list = data?.WishlistListById;

  const isDefault = (list?.id ?? listId) === useWishlistLists.DEFAULT_LIST_ID;

  return {
    listById: {
      __typename: 'WishlistList',
      id: listId ?? '',
      products: [],
      ...list,
      name: isDefault ? formatMessage(messages.defaultListName) : list?.name,
    },
  };
};
